<div class="sdp-dashboard-container">
	<div
		fxLayout="row"
		fxLayoutAlign="start stretch"
	>
		<mat-card
			class="sdp-dashboard-slide"
			[class.sdp-dashboard-slide-short]="!isExpanded"
		>
			<div class="sdp-navigation-container">
				<div *ngFor="let item of data">
					<sdp-navigation-menu-item
						[item]="item"
						[isExpanded]="isExpanded"
						[class.loading]="!isDataLoaded"
					>
					</sdp-navigation-menu-item>
				</div>
			</div>
			<button
				mat-button
				(click)="setExpanded()"
				class="sdp-dashboard-expander"
			>
				<sdp-icon
					[icon]="rotateIcon"
					class="rotate"
					[class.down]="!isExpanded"
				></sdp-icon>
			</button>
		</mat-card>
		<mat-card
			fxFlex
			class="sdp-dashboard-content"
		>
			<div class="sdp-dashboard-content-container">
				<router-outlet></router-outlet>
			</div>
		</mat-card>
	</div>
</div>